export default {
  en: {
    titles: {
      home: 'Home',
      login: 'Login',
      register: 'Register',
      profile: 'Profile',
      logout: 'Logout',
      forgot_password: 'Forgot password',
      reset: 'Reset password',
      email_verification: 'Email verification',
      update_password: 'Update password',
      update_profile: 'Update profile',
      reports: 'Reports',
      create_car_type: 'Create Car Type',
      create_cost_type: 'Create Cost Type',
      create_report: 'Create Report',
      create_service_provider: 'Create Service Provider',
      export_multi_expenses_report: 'Export expenses for selected reports',
      export_multi_expenses_car_uses: 'Export Car Times',
      export_multi_reports: 'Export selected reports',
      export_service_times: 'Export service times',
      select_all: 'Select all',
      clear_selected: 'Clear selected',
      view_report: 'View Report',
      edit_report: 'Edit Report',
      report_details: 'Report Details',
      car_uses: 'Car Uses',
      edit_car_use: 'Edit Car Use',
      service_times: 'Service Times',
      car_times: 'Car Times',
      edit_service_time: 'Edit Service Time',
      total_service_times: 'Total Service Times',
      expenses: 'Expenses',
      edit_expense: 'Edit Expense',
      drivers: 'Drivers',
      contacts: 'Contacts',
      cars: 'Cars',
      create_driver: 'Create Driver',
      create_company: 'Create Company',
      create_contact: 'Create Contact',
      create_country: 'Create Country',
      create_allowance: 'Create Allowance',
      edit_daily_allowance: 'Edit daily allowance',
      edit_driver: 'Edit Driver',
      edit_company: 'Edit Company',
      edit_contact: 'Edit Contact',
      edit_car: 'Edit Car',
      edit_car_type: 'Edit Car Type',
      edit_cost_type: 'Edit Cost Type',
      edit_service_provider: 'Edit Service Provider',
      edit_country: 'Edit Country',
      edit_allowance: 'Edit allowance',
      admins: 'Admins',
      create_admin: 'Create Admin',
      create_job: 'Create Job',
      edit_job: 'Edit Job',
      job_details: 'Job Details',
      edit_admin: 'Edit Admin',
      companies: 'Companies',
      vips: 'VIPs',
      cost_types: 'Cost Types',
      news: 'News',
      create_news_record: 'Create News',
      edit_news_record: 'Edit News Record',
      areas: 'Areas',
      car_owners: 'Car Owners',
      create_car: 'Create Car',
      car_types: 'Car Types',
      sva_export: 'SVA Export',
      entities: 'Entities',
      locked: 'Locked',
      table_filters: 'Table filters',
      selection_options: 'Selection options',
      jobs: 'Jobs',
      scheduled_service_times: 'Scheduled Service Times',
      edit_scheduled_service_time: 'Edit Scheduled Service Time',
      planning_view: 'Planning',
      list_view: 'General',
      new_car: 'New Car',
      new_car_use: 'New Car Use',
      new_service_time: 'New Service Time',
      new_expense: 'New Expense',
      new_daily_allowance: 'New Daily Allowance',
      new_scheduled_service_time: 'New Scheduled Service Time',
      version_history: 'Version History',
      current_version: 'Current Version',
      current_page: 'Current Page',
      changes_detected: 'Changes Detected',
      service_providers: 'Service Providers',
      create_vip: 'Create VIP',
      sort_by_start_timestamp: 'Sort by start time',
      countries: 'Countries',
      allowances: 'Allowances',
      daily_allowances: 'Daily Allowances',
      locations: 'Locations',
      create_location: 'Create Location',
      edit_location: 'Edit Location',
      on: 'On',
      off: 'Off',
      more_options: 'More options',
      create: 'Create',
      leaves: 'Applications of Leave',
      edit_leave: 'Edit Application of Leave',
      total_service_time: 'Total Service Time',
      create_leave: 'Create Application',
      leave_menu: 'Leave',
      cost_type: 'Cost Type',
      edit_vip: 'Edit VIP',
      edit_news: 'Edit News',
      create_news: 'Create News',
      view_news: 'View News',
      price_list: 'Pricelist',
      create_quote: 'Create Quote',
      edit_quote: 'Edit Quote',
      quotes: 'Quotes',
      quote_positions: 'Quote Positions',
      new_quote_position: 'New Quote Position',
      edit_quote_position: 'Edit Quote Position',
      processing: 'Processing',
      release: 'Release',
      new_allowance: 'New Allowance',
      add_new_car: 'Add New Car',
      yes: 'Yes',
      positions: 'Positions',
      position: 'Position',
      no: 'No',
      modified: 'Modified',
      removed: 'Removed',
      added: 'Added',
      downloads: 'Downloads',
      create_download: 'Create Download',
      edit_download: 'Edit Download',
      download_categories: 'Download Categories',
      create_download_category: 'Create Category',
      edit_download_category: 'Edit Category',
      remark_preview: 'Remark',
      notice: 'Notice',
      sva: 'SVA',
      poi: 'POI',
      create_poi: 'Create POI',
      edit_poi: 'Edit POI',
      calendar: 'Calendar',
      leave: 'Leave',
      view: 'View',
      export_drivers: 'Export Drivers',
    },
    fields: {
      language: 'Language',
      time_interval: 'Time Interval',
      color: 'Color',
      avatar: 'Avatar',
      name: 'Name',
      name_de: 'Name (DE)',
      additional_name: 'Name (additional)',
      iso_2_code: 'ISO 2 code e.g (DE, GB, FR)',
      first_name: 'First name',
      last_name: 'Last name',
      mobile_phone: 'Mobile phone',
      phone: 'Phone',
      birthdate: 'Birthdate',
      company: 'Company',
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Password confirmation',
      repeat_password: 'Repeat password',
      current_password: 'Current password',
      new_password: 'New password',
      new_password_repeat: 'Repeat new password',
      gender: 'Gender',
      dob: 'Date of birth',
      licenses: 'Licenses',
      street: 'Street',
      postal_code: 'Postal code',
      town: 'Town',
      country: 'Country',
      nationality: 'Nationality',
      bank_name: 'Bank name',
      iban: 'IBAN',
      bic: 'BIC',
      customer: 'Customer',
      vip: 'VIP',
      meeting_point: 'Meeting Point',
      job_location: 'Job Location',
      city_location: 'City / Location',
      meeting_date: 'Meeting Date & Time',
      start_date_and_time: 'Start Date & Time',
      notes: 'Notes',
      remark: 'Remark',
      payment_link: 'Payment Link',
      car_type: 'Car Type',
      license_plate: 'License Plate (e.g. LEV KK 36)',
      license_plate_format: 'License Plate (format: LEV KK 49)',
      owner: 'Owner',
      created_by: 'Created by',
      takeover_from: 'Takeover From',
      return_to: 'Return To',
      takeover_date: 'Takeover',
      return_date: 'Return',
      km_status_takeover: 'Mileage Takeover',
      km_status_return: 'Mileage Return',
      total_km: 'Total km',
      total_time: 'Total Time',
      car_use: 'Car Use',
      date: 'Date',
      approach_start: 'Approach Start',
      approach_end: 'Approach End',
      service_start: 'Service Start',
      service_end: 'Service End',
      return_start: 'Return Start',
      return_end: 'Return End',
      idle_time: 'Idle Time',
      km_driven: 'KM driven',
      cost_type: 'Cost Type',
      amount: 'Amount (€)',
      description: 'Description',
      description_optional: 'Description (optional)',
      roles: 'Roles',
      driver: 'Driver',
      locked: 'Lock Status',
      images: 'Images (submit the form to save changes)',
      content: 'Content',
      title: 'Title',
      areas: 'Areas',
      area: 'Area',
      area_from: 'Area from',
      area_to: 'Area to',
      location_from: 'Location from',
      location_to: 'Location to',
      contact: 'Contact',
      organizers: 'Organizers',
      organizer: 'Organizer',
      vip_description: 'VIP Description',
      vat_number: 'VAT number',
      debitor_number: 'Debitor number',
      mobile_number: 'Mobile number',
      creditor_number: 'Creditor number',
      id_card_number: 'ID card number',
      driving_license_number: 'Driving license number',
      transport_license_date: 'Exp. date passenger transport license',
      id_card: 'ID card upload',
      driving_license: 'Driving license upload',
      transport_license: 'Passenger transport license upload',
      zub: 'Registration',
      status: 'Status',
      paid: 'Paid',
      car_use_paid: 'Car Use paid',
      abroad: 'Abroad',
      sex: {
        1: 'Male',
        2: 'Female',
        3: 'Divers',
      },
      verified: 'Verified',
      sva_print: 'SVA print',
      sva: 'SVA',
      admin_drafts_also: 'My drafts',
      all_drafts_also: 'Include Drafts',
      completed_and_draft: 'Completed & Draft',
      draft_only: 'Draft',
      completed: 'Completed',
      none_drafts: 'No Drafts',
      export_select: 'Select to download multiple expenses reports',
      invoice_select: 'Select to update invoice number',
      multi_report_export_select: 'Select to download multiple reports',
      sum_service_times_select: 'Select to sum up service times',
      invoice_number: 'Invoice Number',
      export_expenses: 'Export Expenses',
      export: 'Export',
      show_deleted_records: 'Show deleted records',
      username: 'Username',
      contact_not_in_company: 'Contact not in company',
      starting_location: 'Starting location',
      target_location: 'Target location',
      link: 'Link',
      link_with: 'Link with',
      report: 'Report',
      attachments: 'Attachments',
      destination: 'Destination',
      homepage_content_option: 'Select section as homepage',
      homepage_content_default: 'Default: News',
      use_existing_car: 'Use existing car',
      start_date: 'Start Date',
      times_registered: 'Times Registered',
      times_listed: 'Times Listed',
      service_provider: 'Service Provider',
      executor: 'Executor',
      driver_or_service_provider: 'Driver / Service Provider',
      phone_number: 'Phone number',
      company_name: 'Company name',
      select_option: 'Select option',
      selection_options: 'Options',
      change_customer: 'Select to change customer',
      change_service_times: 'Select to change service times',
      change_vip: 'Select to change VIP',
      search: 'Search',
      change_locations: 'Select to change locations',
      change_car: 'Select to change car type',
      add_report: 'Add report',
      select_to_add_report: 'Select to add report',
      select_to_delete: 'Select to delete scheduled service time',
      order: 'Order (0 is first)',
      allowance_type: 'Allowance type',
      meals_8: 'Verpflegung 8 < 24h',
      meals_24: 'Verpflegung 24h',
      absence_start: 'Absence start time',
      absence_end: 'Absence end time',
      total_absence: 'Total absence',
      meals: 'Verpflegung',
      meal_type: 'Meal type',
      overnight_stay: 'Übernachtung',
      ride_cost: 'Fahrtkosten',
      kilometers: 'Amount of kilometers',
      locations: 'Locations',
      areas_and_locations: 'Areas & Locations',
      interval_start: 'Interval Start',
      interval_end: 'Interval End',
      end_date: 'End Date',
      amount_of_days: 'Amount of Days',
      confirmed: 'Confirmed',
      additional_costs: 'Additional Costs',
      client: 'Client',
      only_costs: 'Only Costs',
      scan: 'Scan',
      upload: 'Upload',
      invoicing_details: 'Invoicing Details',
      version: 'Version',
      created_at: 'Created at',
      current: 'Current',
      field: 'Field',
      previous_value: 'Previous Value',
      current_value: 'Current Value',
      updated_by: 'Updated by',
      english: 'English',
      german: 'Deutsch',
      language_version: 'Language Version',
      add_tax: 'Umsatzsteuer ausweisen',
      cancellation_policy: 'Stornierungsbedingungen',
      payment_terms: 'Zahlungsbedingungen',
      add_notes: 'Anmerkungen',
      price: 'Price',
      just_amount: 'Amount',
      just_info: 'Just info',
      custom_description: 'Custom description',
      admin: 'Admin',
      remarks: 'Remarks',
      invoice_issuer: 'Rechnungssteller',
      release_for: 'Release for',
      position: 'Position',
      category: 'Category',
      attachment: 'Attachment',
      google_maps: 'Google Maps Link',
      location: 'Location',
      show_remark: 'Show Remark',
      show_google_link: 'Show Google Maps Link',
      including_zub: 'Including ZUB',
      drivers_export: 'Select to create list of drivers',
    },
    table_labels: {
      id: '#',
      color: 'Color',
      from_date: 'From Date',
      timeline: 'Timeline',
      select: '✓',
      to_date: 'To Date',
      area_from: 'Area From',
      area_to: 'Area to',
      view: 'View',
      avatar: 'Avatar',
      title: 'Title',
      driver: 'Driver',
      customer: 'Customer',
      company: 'Company',
      contact: 'Contact',
      area: 'Area',
      start_time: 'Start Time',
      organizers: 'Organizers',
      organizer: 'Organizer',
      vip: 'VIP',
      car: 'Car',
      meeting_point: 'Meet. Point',
      meeting_date: 'Meet. Date',
      actions: 'Actions',
      total_approach: 'Total Approach',
      total_service: 'Total Service',
      total_return: 'Total Return',
      total_time: 'Total Time',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      mobile_phone: 'Mobile',
      phone: 'Phone',
      birthdate: 'Birthdate',
      verified: 'Verified',
      roles: 'Roles',
      role: 'Role',
      areas: 'Areas',
      status: 'Status',
      completed: 'Completed',
      owner: 'Owner',
      created_by: 'Created by',
      created_at: 'Created at',
      date: 'Date',
      sva_print: 'SVA print',
      lic_plate: 'Lic. plate',
      license_plate: 'License Plate',
      zub: 'ZUB',
      car_type: 'Car Type',
      mobile_number: 'Mobile',
      invoice_number: 'Invoice',
      name: 'Name',
      street: 'Street',
      postal_code: 'Postal code',
      town: 'Town',
      country: 'Country',
      vat_number: 'VAT',
      debitor_number: 'Debitor',
      start_date: 'Start Date',
      phone_number: 'Phone number',
      company_name: 'Company name',
      driver_or_service_provider: 'Driver / S. Prov.',
      order: 'Order',
      name_de: 'Name (DE)',
      iso_2_code: 'ISO 2 code',
      allowance_type: 'Allowance type',
      meals: 'Verpflegung 8 < 24',
      meals_24: 'Verpflegung 24h',
      overnight_stay: 'Übernachtung',
      ride_cost: 'Fahrtkosten',
      amount: 'Amount',
      report: 'Report #',
      description: 'Description',
      total_amount: 'Total amount (€)',
      paid: 'Paid',
      location_from: 'Loc. from',
      location_to: 'Loc. to',
      end_date: 'End Date',
      amount_of_days: 'Amount of Days',
      confirmed: 'Confirmed',
      total_service_time: 'Total Service Time',
      job_location: 'Job Location',
      client: 'Client',
      active: 'Active',
      last_job: 'Last Job',
      topic: 'Topic',
      unit_price: 'Unit Price (€)',
      sum_price: 'Sum Price (€)',
      total:' Total (€)',
      subtotal: 'Subtotal (€)',
      incl_tax: 'incl. tax',
      position: 'Pos.',
      location: 'Location',
      sva: 'SVA',
      expenses_uploaded: 'Exp. uploaded',
      attachment: 'Attachment',
      city_and_location: 'City / Location',
    },
    placeholders: {
      avatar: 'Select image',
      name: 'Enter name',
      first_name: 'Enter first name',
      last_name: 'Enter last name',
      phone: 'Phone',
      mobile_phone: 'Mobile phone',
      company: 'Search and select company',
      email: 'Enter email',
      password: 'Enter password',
      password_confirmation: 'Enter password confirmation',
      current_password: 'Enter current password',
      new_password_repeat: 'Repeat new password',
      description: 'Enter description',
      comment: 'Enter comment',
      date: 'Enter date',
      licenses: 'Enter licenses',
      street: 'Enter street',
      postal_code: 'Enter postal code',
      town: 'Enter town',
      country: 'Enter country',
      nationality: 'Enter nationality',
      bank_name: 'Enter bank name',
      iban: 'Enter IBAN',
      bic: 'Enter BIC',
      search: 'Start typing to search',
      customer: 'Start typing to search a customer',
      vip: 'Search and select VIP',
      meeting_point: 'Enter meeting point',
      city_location: 'Enter city or location',
      notes: 'Enter notes (optional)',
      remark: 'Enter remark (optional)',
      car_type: 'Select a car',
      license_plate: 'LEV KK 36',
      created_by: 'Start typing to search by created by user',
      owner: 'Start typing to search and select an owner',
      takeover_from: 'Takeover from',
      return_to: 'Return to',
      km_status_takeover: 'Enter km-status takeover',
      km_status_return: 'Enter km-status return',
      car_use: 'Select car use',
      approach_start: 'Enter Approach Start Time',
      approach_end: 'Enter Approach End Time',
      service_start: 'Enter Service Start Time',
      service_end: 'Enter Service End Time',
      return_start: 'Enter Return Start Time',
      return_end: 'Enter Return End Time',
      idle_time: 'Enter Idle Time',
      km_driven: 'Enter KM driven',
      cost_type: 'Select cost type',
      amount: 'Select amount',
      driver: 'Start typing to search and select a driver',
      content: 'Enter content',
      title: 'Enter title',
      areas_dropdown: 'Select area from list',
      locations_dropdown: 'Select multiple locations from list',
      areas: 'Search and select multiple areas',
      area: 'Search and select area',
      select_area: 'Select area',
      status: 'Please select status',
      contact: 'Search and select contact',
      contact_name: 'Enter contact name',
      organizers: 'Search and select multiple organizers',
      organizer: 'Search and select organizer',
      vip_description: 'Enter VIP description',
      vat_number: 'Enter VAT number',
      debitor_number: 'Enter debitor number',
      mobile_number: 'Enter mobile number',
      creditor_number: 'Enter creditor number',
      id_card_number: 'Enter ID card number',
      driving_license_number: 'Enter driving license number',
      transport_license_date: 'Enter exp. date passenger trasport license',
      id_card: 'Choose file (jpeg, png, gif, pdf)',
      driving_license: 'Choose file (jpeg, png, gif, pdf)',
      transport_license: 'Choose file (jpeg, png, gif)',
      zub: 'Choose ZUB Teil 1 (jpeg, png, gif)',
      scan: 'Choose Scan (jpeg, png, gif, pdf)',
      date_interval_start: 'Interval Start',
      date_interval_end: 'Interval End',
      invoice_number: 'Please enter invoice number',
      username: 'Username',
      starting_location: 'Enter starting location',
      target_location: 'Enter target location',
      report: 'Search and select report',
      attachments: 'Select file (pdf, doc, xls, jpg, png)',
      destination: 'Enter destination',
      start_date: 'Start Date',
      times_registered: 'Times Registered',
      service_provider: 'Select Service Provider',
      phone_number: 'Enter phone number',
      company_name: 'Enter company name',
      search_license_plate: 'Search and select license plate',
      iso_2_code: 'Enter ISO 2 country code',
      order: 'Enter order number',
      name_de: 'Enter name in German language',
      allowance_type: 'Select allowance type',
      meals: 'Enter Verpflegung 8<24h',
      meals_24: 'Enter Verpflegung 24h',
      overnight_stay: 'Enter Übernachtung',
      select_country: 'Select country',
      meal_type: 'Select meal type',
      kilometers: 'Enter kilometers',
      time: 'Enter time',
      total_service_time: 'Total Service Time',
      enter_at_least_three_letters: 'Enter at least 3 letters',
      locations: 'Locations',
      areas_and_locations_multiple: 'Search and select multiple areas & locations',
      location: 'Search and select location',
      locations_multiselect: 'Select multiple locations',
      select_date: 'Select Date',
      select_amount: 'Select amount',
      select_description: 'Select description',
      price: 'Enter price (€)',
      enter_custom_description: 'Enter custom description',
      remarks: 'Enter remarks',
      release_for: 'Select admin to release for',
      license_plate_from_db: 'Select from database',
      enter_license_plate: 'Enter license plate',
      enter_amount: 'Enter amount',
      select_category: 'Select category',
      google_maps: 'Enter Google Maps link',
      select_file: 'Select file (pdf, jpg, png)',
      select_file_with_mp4: 'Select file (pdf, jpg, png, mp4)',
      enter_details: 'Enter details',
      additional_name: 'Enter additional name',
    },
    actions: {
      list: 'List',
      today: 'Today',
      continue: 'Continue',
      forgot_password: 'Forgot password?',
      register_now: 'Register now',
      send_forgot_password: 'Request password change',
      submit: 'Submit',
      ok: 'OK',
      stop: 'Cancel',
      clear: 'Clear',
      lock: 'Lock',
      unlock: 'Unlock',
      add_image: 'Add image',
      export_expenses: 'Expenses pdf',
      export_report: 'Report pdf',
      export_allowances: 'Allowances pdf',
      export: 'Export',
      export_pdf: 'Export pdf',
      unlink: 'Unlink',
      make_admin: 'Make admin',
      delete: 'Delete',
      restore: 'Restore',
      edit: 'Edit',
      duplicate: 'Duplicate',
      remove: 'Remove',
      update: 'Update',
      add_new: 'Add new',
      mark_car_use_paid: 'Mark as paid',
      add_new_invoice_number: 'Add invoice number',
      reset: 'Reset',
      take_over_editing: 'Take over editing',
      confirm: 'Confirm',
      unconfirm: 'Unconfirm',
      add: 'Add',
      sum: 'Sum',
      cancel_de: 'Abbrechen',
      download: 'Download',
      dismiss: 'Dismiss',
      dismissed: 'Dismissed',
      changes: 'Changes',
      new_version: 'New Version',
      view: 'View',
      view_current_version: 'View Current Version',
      create_job: 'Create Job',
      select_from_list: 'Select from list',
      release: 'Release',
      upload: 'Upload',
      calendar: 'Calendar',
    },
    messages: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      how_many_duplicates: 'How many duplicates do you want to add?',
      forgot_password_sent: 'The recovery link has been sent to your email address.',
      password_changed: 'The password has been reset. You can log in now.',
      no_items: 'Nothing to display',
      empty_list: 'The list is empty.',
      select_category_first: 'Select category first',
      multiselect_enter: 'Enter at least 2 letters.',
      export_in_progress: 'Generating the export, this can take a while. Please wait...',
      please_send: 'Please send all original receipts clearly labeled with the expense-ID (red / e.g. #149) to:',
      // own_interest: 'In your own interest, please take a copy of the documents before sending.',
      own_interest: 'In eurem eigenen Interesse bitten wir euch, eine Kopie der Belege zu machen bevor ihr sie verschickt.', // TODO fix german/english langs
      no_more_news: 'There are no more news',
      before_address:
        'Nach Abschluss des Reports die Auslagenabrechnung herunterladen, und per Email an folgende Adresse senden: expenses@kks-hahn.de',
      please_enter_absence_times: 'Please enter absence start and absence end fields.',
      daily_allowances: 'Nach Abschluss der Eingaben die Reisekostenabrechnung herunterladen, und per Email an die Büro- oder Projektleitung senden.',
      confirm_leave: 'Confirm this application?',
      no_changes_detected: 'No changes detected',
      viewing_old_version: 'You are viewing an old version',
      loading_comparison: 'Loading comparison...',
      version_created: 'New version created',
    },
    errors: {
      terms: 'You must accept the privacy policy to continue the registration.',
      period_not_legitimate_for_allowance: 'This period is not legitimate for allowance.',
      report_status_not_completed: 'Report status not completed.',
      report_status_completed_expenses_not_uploaded: 'To complete report all expenses scans must be uploaded',
      service_end_after_service_start: 'Service End must be after Service Start',
      create_job_from_quote: 'Cannot create job from quote.',
    },
    infos: {
      area: 'Wo findet der Job statt, Inland oder Ausland (Abroad)?',
      currently_editing: 'Currently editing:',
      export_daily_allowances_pdf_info: 'Download Reisekostenabrechnung pdf',
      daily_allowance_info: '<p class="text-center">Reisekosten können nur nach vorheriger Absprache mit der Büroleitung eingetragen & abgerechnet werden!</p>',
      sort_by_start_timestamp: 'It will override selected table sorting when enabled.',
      licenses:
        'Describe your driving license and other licenses to transport passengers etc. | Beschreiben Sie Ihren Führerschein und andere Lizenzen für die Beförderung von Passagieren usw.',
      bic: 'Only necessary for accounts outside of Germany | Nur bei Konten außerhalb Deutschlands notwendig',
      meeting_point: 'Ort an dem der Einsatz beginnt',
      meeting_date: 'Start-Zeitpunkt des Einsatzes',
      meeting_notes: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      takeover_from: 'Person oder Firma, die dir das Fahrzeug übergeben hat.',
      return_to: 'Person oder Firma, an die das Fahrzeug übergeben wurde.',
      takeover_date: 'Zeitpunkt der Fahrzeugübernahme',
      return_date: 'Zeitpunkt der Fahrzeugrückgabe',
      km_status_takeover: 'Kilometerstand Fahrzeugübernahme',
      km_status_return: 'Kilometerstand Fahrzeugrückgabe. Bitte bei Langzeitmieten und Transportern eintragen.',
      approach_start: 'Beginn der Anfahrt',
      approach_end: 'Ende der Anfahrt',
      service_start: 'Beginn des Fahrdienst',
      service_end: 'Ende des Fahrdienst',
      return_start: 'Beginn der Abfahrt',
      return_end: 'Ende der Abfahrt',
      idle_time: 'Idle time | Standzeit',
      km_driven: 'KM driven',
      licence_plate: 'Kennzeichen',
      vip_description: 'Es muss das Feld „VIP" ODER das Feld "VIP description" ausgefüllt sein, um den Bericht zu speichern.',
      id_card_number: 'Personalausweisnummer',
      transport_license_date: 'Ablaufdatum des Personenbeförderungsschein',
      zub: 'Bitte hier ein Foto der ersten Seite des Fahrzeugscheins hochladen.',
      status: 'Draft = Bearbeitungsmodus / ' + 'Completed = Bearbeitung abgeschlossen',
      car_type: 'Fahrzeugtyp',
      car_owner: 'Fahrzeughalter',
      car_use: 'Verwendetes Fahrzeug',
      date: 'Auftragsdatum',
      cost_type: 'Auswahl der Kostenart. Bitte beachtet den Steuersatz und ob die Kosten in Deutschland oder im Ausland angefallen sind.',
      expense_date: 'Datum an dem die Kosten angefallen sind',
      amount: 'Betrag in Euro',
      amount_description: 'Kurze Erklärung der Kosten',
      report_selection_info:
        'Dieser Schalter definiert, ob die Checkboxen zum Auswählen eines gleichzeitigen Exports mehrerer Berichte, oder zur Auswahl von Berichten, denen einen Rechnungsnummer hinzugefügt werden soll, dienen.',
      export_expenses: 'Wenn diese Option deaktiviert ist, steht der Export von Ausgaben für diesen Bericht nicht zur Verfügung.',
      meals: 'Auswahl der Mahlzeiten die während der Abwesenheit geltend gemacht werden sollen',
      unsupported_meals: '<p class="text-center">Diese Eingaben führen zu einem Wert von € 0,00 und können nicht aufgenommen werden!</p>',
      leave_confirmed_by: 'Confirmed by {name} at {date}',
      loading_notifications: 'Loading notifications...',
      empty_notifications: 'Notifications empty',
      showing_results: '{start} - {end} of {total}',
      job_location: 'Ort des Auftrags',
      current_file: 'Current file',
      uploading: 'Uploading...',
    },
    search: {
      message: '(by {entity})',
      planning_view_info: 'Search by VIP, Driver/Service Provider, License Plate, Car Type',
      entities: {
        customer: 'Customer',
        vip: 'VIP',
        meeting_point: 'Meeting Point',
        driver: 'Driver',
        name: 'Name',
        email: 'Email',
        license_plate: 'License Plate',
        invoice_number: 'Invoice Number',
        company: 'Company',
        contact: 'Contact',
        location: 'Location',
        id: 'ID',
        organizer: 'Organizer',
        car_type: 'Car Type',
        service_provider: 'Service Provider',
        cost_type: 'Cost Type',
        quote: 'Quote',
        quote_position: 'Quote Position',
        edit_quote_position: 'Edit Quote Position',
        create_quote_position: 'Create Quote Position',
      },
      name: 'Name',
      name_de: 'Name (DE)',
      status: 'Status',
      drafts: 'Drafts',
      edit_status: 'Edit Status',
      lock_status: {
        label: 'Lock Status',
        locked: 'Locked',
        unlocked: 'Unlocked',
        all: 'Locked & Unlocked',
      },
      invoice: {
        all_reports: 'All reports',
        no_number: 'No number',
      }
    },
    entities: {
      report: 'report',
      car_use: 'car-use',
      service_time: 'service-time',
      scheduled_service_time: 'scheduled-service-time',
      expense: 'expense',
      news_record: 'news record',
      driver: 'driver',
      admin: 'admin',
      car: 'Car',
      job: 'Job',
      service_provider: 'Service Provider',
      contact: 'Contact',
      vip: 'VIP',
      country: 'Country',
      allowance: 'Allowance',
      daily_allowance: 'Daily allowance',
      location: 'Location',
      leave: 'Leave',
      cost_type: 'Cost Type',
      quote: 'Quote',
      quote_position: 'Quote Position',
      download: 'download',
      download_category: 'download category',
      point_of_interest: 'POI',
    },
    alerts: {
      delete_entity: 'Are you sure that you want to delete this {entity}?',
      duplicate_entity: 'Do you want to duplicate this {entity}?',
      lock_entity: 'Are you sure, the you want change status of this {entity}?',
      restore_entity: 'Are you sure that you want to restore this {entity} and all of his entities?',
      report_link: 'Because car and driver (or report) is selected, this scheduled service time will be disabled for editing until report is unlinked.',
      warning: 'Warning',
      make_driver_admin: 'Are you sure you want to make this driver as Admin?',
      remove_driver_admin: 'Are you sure you want to remove Admin rights from this driver?',
      info: 'Info',
      create_job_from_quote: 'Are you sure you want to create a job from this quote?',
    },
    copyright: '© 2023 KKS',
    name: 'KKS',
    tos: 'Privacy Policy',
    term: 'I accept the {0} from KKS',
  },
};
